/*
 * @Desc: 文件描述
 * @Author: jiayi zhu
 * @Date: 2020-12-01 14:55:52
 * @LastEditors: wangDong Xu
 */
export default [
  {
    path: '/',
    page: 'index'
  },
  {
    path: '/easy/equity/coupons',
    page: 'coupons',
    name: 'app——easy会员红包权益领取'
  },
  {
    path: '/easy/equity/snacks',
    page: 'snacks',
    name: 'app——easy会员零食权益领取'
  },
  // 联合会员购买成功后的跳转地址，小程序及APP有跳转到这个页面
  {
    path: '/easy/exchange/scale',
    page: 'member-center/super-member',
    name: '薄荷会员权益'
  },
  {
    path: '/associate-member/member-index',
    page: 'member-sales-page',
    name: '开通联合会员',
    erorElement: 'Error'
  },
  {
    path: '/associate-member/privilegePage',
    page: 'privilege-page',
    name: '薄荷联合会员权益'
  },
  {
    path: '/integral-center',
    page: 'integral-center/index',
    name: '积分中心'
  },
  {
    path: '/integral-center/detail',
    page: 'integral-center/detail/index',
    name: '积分明细'
  },
  {
    path: '/multiply-channel',
    page: 'multiply-channel',
    name: '全渠道会员'
  },
  {
    path: '/classic-recipe',
    page: 'classic-recipe',
    name: '精品食谱'
  },
  {
    path: '/classic-recipe-detail/:id',
    page: 'classic-recipe-detail',
    name: '精品食谱详情'
  },
  {
    path: '/excellent-course',
    page: 'excellent-course',
    name: '营养课程'
  },
  {
    path: '/excellent-course-list',
    page: 'excellent-course-list',
    name: '营养课程列表'
  },
  {
    path: '/recipe-course-nav',
    page: 'recipe-course-nav',
    name: '课程和菜谱跳转页'
  },
  {
    path: '/member-sale',
    page: 'member-sales-page',
    name: '血糖' // 根据不同类型，展示不同图片
  },
  {
    path: '/member-sale-food',
    page: 'member-sales-food-page',
    name: '饮食计划会员销售页面'
  },
  // 新版营养课程
  {
    path: '/nutrition-course',
    page: 'nutrition-course',
    name: '营养课程'
  },
  // 新版精品食谱
  {
    path: '/boutique-recipe',
    page: 'boutique-recipe',
    name: '精品食谱'
  },
  // 薄荷 APP 首页会员功能
  {
    path: '/health-home-member',
    page: 'health-home-member',
    name: '薄荷首页会员'
  },
  // 薄荷 APP 首页会员音频课程
  {
    path: '/home-member-audio-list',
    page: 'health-home-member/audio-list',
    name: '音频课程'
  },
  // 薄荷 APP 首页会员音频播放列表
  {
    path: '/home-member-audio-list-detail',
    page: 'health-home-member/audio-list-detail',
    name: '音频播放列表'
  },
  // 音频播放页面
  {
    path: '/audio-paly-page',
    page: 'health-home-member/audio-paly-page',
    name: '音频播放'
  },

  {
    path: '/easy/index',
    page: 'member-center/super-member',
    name: 'app——easy会员首页'
  },
  {
    path: '/easy/introduce',
    page: 'member-center/super-member',
    name: 'app——easy会员购买入口'
  },
  {
    path: '/member-center',
    page: 'member-center/super-member',
    name: '会员中心' // 统一为最新的超级会员页面
  },
  {
    path: '/super-member',
    page: 'member-center/super-member',
    name: '超级会员' // 新修改
  },
  {
    path: '/check',
    page: 'check',
    name: '漏洞检查' // 新修改
  },
  {
    path: '/member-discounts',
    page: 'member-discounts',
    name: '血糖'
  },
  {
    path: '/vip-month',
    page: 'vip-month',
    name: '月会员0元试用'
  },
  {
    path: '/member-skin',
    page: 'member-skin',
    name: '主题皮肤'
  },
  {
    path: '/die-advice-member-pay',
    page: 'die-advice-member-pay',
    name: '饮食建议会员销售页面'
  },
  {
    path: '/half-year-member',
    page: 'half-year-member',
    name: '半年会员销售页面'
  },
  {
    path: '/dynamic-recipe-member-pay',
    page: 'dynamic-recipe-member-pay',
    name: '智能食谱会员销售页面'
  },
  {
    path: '/record-photo-member-pay',
    page: 'record-photo-member-pay',
    name: '拍照记录会员销售页面'
  },
  {
    path: '/trophic-analysis-new',
    page: 'trophic-analysis',
    name: '营养分析'
  },
  {
    path: '/member-center/toolkits',
    page: 'member-center/toolkits',
    name: '会员专享工具'
  },
  {
    path: '/member-center/skins',
    page: 'member-center/skins',
    name: '会员专享皮肤'
  },
  {
    path: '/member-weight-manage-pay',
    page: 'member-weight-manage-pay',
    name: '体重管理方案'
  },
  {
    path: '/weekly-summary-sales',
    page: 'weekly-summary-sales',
    name: '掉秤周报'
  },
  {
    path: '/blood-member-sale',
    page: 'blood-member-sales-page',
    name: '血糖会员销售页' // 根据不同类型，展示不同图片
  },
  {
    path: '/address',
    page: 'address',
    name: '地址管理'
  },
  {
    path: '/address/:type',
    page: 'address-change',
    name: '地址'
  }, {
    path: '/test_blood',
    page: 'test_blood',
    name: '测试地址'
  },
  {
    path: '/glp1-member-sales',
    page: 'glp1-member-sales',
    name: 'glp饮食建议会员销售'
  },
  {
    path: '/glp1-analysis-sales',
    page: 'glp1-analysis-sales',
    name: 'glp营养分析会员销售'
  },
  {
    path: '/241210-sales',
    page: '241210-sales',
    name: '销售页面'
  },
  {
    path: '/boold-pay',
    page: 'blood-member-sales-page/boold-pay',
    name: '测试 a销售页面'
  },
  {
    path: '/blood-delete-sales-page',
    page: 'blood-delete-sales-page',
    name: '划线价销售页面'
  }, {
    path: '/ai-calculated-sales',
    page: 'ai-calculated-sales',
    name: 'ai计算热量会员销售'
  }
];
